var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"reserve-list"},[_c('div',{staticClass:"reserve-list-container"},[_c('list-reserve')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }